<div class="buttons-tool" [hidden]="loading || !buttons">
  <button type="button" class="default zoom-out-img" (click)="zoomOut()" title="Zoom Out">
    <span class="zoomOut">Zoom Out</span>
  </button>
  <button type="button" class="default zoom-in-img" (click)="zoomIn()" title="Zoom In">
    <span class="zoomIn">Zoom In</span>
  </button>
  <button type="button" class="default rotate-img" (click)="rotate()" title="Rotate">
    <span class="rotate">Rotate</span>
  </button>

</div>

<img
  [src]="src"
  [ngStyle]="viewer.style"
  alt="Image not found..."
  (load)="imgLoaded($event)"
  (loadstart)="imgLoadStart()"
/>
<!-- div for ghost image??-->
<div></div>

<core-helpers-box-loading [hidden]="!loading"></core-helpers-box-loading>
